<template>
  <div class="person">
    <div class="person__avatar">
      <SmAvatar :name="props.person?.name || props.person?.email || '??'" />
    </div>
    <div class="person__information">
      <div class="person__name">
        {{ props.person?.name }}
      </div>
      <div class="person__email">
        {{ props.person?.email }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Account } from '@/client'

  const props = defineProps({
    person: {
      type: Object as PropType<Account>,
      required: true,
    },
  })
</script>

<style lang="scss" scoped>
  .person {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem;

    &__avatar {
      margin-right: 1rem;
      border-radius: var(--border-radius-base);
      box-shadow: var(--shadow);
      background-color: var(--sm-white);
    }

    &__information {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &__name {
      font-weight: 600;
    }

    &__email {
      color: var(--el-text-color-secondary);
    }
  }
</style>
